'use strict';

const anchorTokens = (theme) => ({
    anchorTextColor: theme.colors.primary.normal,
    anchorTextDecoration: 'none',
    anchorHoverTextDecoration: 'underline',
    anchorFocusTextDecoration: 'underline',
    anchorFocusTextColor: theme.colors.primary.dark,
});

exports.anchorTokens = anchorTokens;
//# sourceMappingURL=anchor.js.map
